
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/research-studies/science-class-engagement",
      function () {
        return require("private-next-pages/research-studies/science-class-engagement.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/research-studies/science-class-engagement"])
      });
    }
  